import axios from 'axios';
// import qs from 'qs';
import {keycloak} from "../keycloak-config";

function headersWithAuth(withDefaultHeaders, auth = true) {
  let props = {};
  if (!auth) return {};
  if (keycloak.authenticated) {
    props['Authorization'] = `Bearer ${keycloak.token}`;
  }

  if (withDefaultHeaders) {
    props = {
      ...props,
      'Content-Type': 'application/json',
      "accept": "application/json",
      "X-Requested-With": " XMLHttpRequest",
    }
  }
  return props;
}

interface OptionsType {
  [key: string]: boolean
}
interface ClientOptions {
  url: string,
  method?: string,
  headers?: object,
  options?: OptionsType,
  data?: object,
  attachments?: any,
  withDefaultHeaders?: boolean,
}

export default function client({
  url,
  method = 'get',
  headers = {},
  options = { withAuth: true },
  data,
  attachments,
  withDefaultHeaders = true,
}: ClientOptions) {

  const { withAuth } = options;
  const requestConfig = {
    method,
    headers: {
      ...headersWithAuth(withDefaultHeaders, withAuth),
      ...headers
    },
  };

  if (typeof data === 'object' && !attachments) {
    requestConfig['data'] = { ...data };
  }

  if (attachments && typeof attachments === 'object') {
    const _data = new FormData();

    Object.keys(attachments).forEach((c) => {
      _data.append(c, attachments[c]);
    });
    requestConfig['data'] = _data;
  }

  return axios(`/api/v1/${url}`, requestConfig)
    .then((res) => res.data)
    .catch(({ response = {} }) => {
      const error = { data: response.data, status: response.status};
      throw error;
    });
}
